import React, {  useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "./../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";
import HeadingSection from "../../components/HeadingSection/HeadingSection";
import FunFactsArchitecture3 from "../../components/FunFacts/FunFactsArchitecture3";
import Gallery from "../../components/Gallery/Gallery";



import CTAOne from "../../components/CTA/CTAOne";


const paragraph2 = (
  <>
    {`Here's How ${new Date().getFullYear()} Is Adding Up So Far:`}
    <br />
    {`YTD Average Price Comparison of All Property Types`}
  </>
);

const Architecture = () => {
  // const home = useRef();
  // const about = useRef();
  const sales = useRef();
  // const service = useRef();
  // const agents = useRef(); 
  // const rentals = useRef();
  const contact = useRef();

  // const scrollToSection = (e, content) => {
  //   e.preventDefault();
  //   switch (content) {
  //     case "home":
  //       home.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "about":
  //       about.current.scrollIntoView({ behavior: "smooth" });
  //         break;
  //     case "sales":
  //       sales.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "service":
  //       service.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "agents":
  //       agents.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "rentals":
  //       rentals.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     case "contact":
  //       contact.current.scrollIntoView({ behavior: "smooth" });
  //       break;
  //     default:
  //   }
  // };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className=" mt-minus-50">
        <div className="container mt-minus-50">
      <div className="row mt-minus-50">
        <HeadingSection
       
          classAppend="dark-color"
        > <h2>OUR SERVICES</h2></HeadingSection>
      </div>
     
     <h2>OLSHAN ESTATE SOLUTIONS</h2><br />


<p><strong>Olshan Estate Solutions</strong> Solutions offers specialized expertise to executors and estate attorneys who need to maximize the sale price of estate homes and apartments in the quickest, most-stress free way possible. We oversee all phases of preparation and sale, making Olshan the perfect teammate to assist in the difficult time of estate liquidation.</p>

<p><h5>Typical services provided for our Estate Sale Solution properties include the following:</h5>
<ul>
<li><strong>Securing the property</strong>, rekeying, turning on utilities, arranging for HOA payments</li>
<li><strong>Estate Liquidation -</strong> Furniture/Personal Property Move Out/Donations/Trashouts</li>
<li><strong>Property Evaluation/Evaluation/Broker Price Opinion (BPO)</strong></li>
<li><strong>Fix Up and Stage to Maximize Sale Price</strong> and minimize carrying costs</li>
<li><strong>Sale of Home</strong> to Qualified Buyer</li>
<li><strong>Obtaining Coop/Condo Board Approval</strong></li>
</ul></p>

<p>Our vetted team of contractors can quickly give a tired apartment a "facelift", and professionally stage it with existing furniture, or go for a newer, modern take to ensure the highest sale price for the estate.</p>

<p>Each Olshan Estate agent has over 25 years experience in the sales and property management industry, and will be your personal point of contact to oversee the preparation and sale of the home. We can assist homeowners in <strong>Manhattan, Brooklyn, and Southern Westchester.</strong></p>

<p>For more information, contact Donna Olshan at 917-287-0458, or via email at <a href="MAILTO:dso@olshan.com">dso@olshan.com</a>. All inquiries will be kept confidential.</p>


    </div>
    </section>

    <FunFactsArchitecture3
                
                title={new Date().getFullYear()}
                tagline="By The Numbers"
                paragraph1="In 2024 the average asking price in the luxury sector ($4 million and above) was 4%
                higher than 2023. Once again, condos outsold co-ops more than 3-to-1, reflecting an ongoing trend: The
                average luxury buyer wants the freedom of condo ownership, new construction, and a
                robust menu of amenities. Townhouse sales were flat."
                paragraph2={paragraph2}  paragraph3={`FOR PROPERTIES $4 MILLION AND ABOVE`}  paragraph4={<div dangerouslySetInnerHTML={{ __html: 'Data sourced from The Olshan Realty <a class="underline" href="/market-report">Luxury Market Report</a>.' }} />}
              />

              
    <Gallery
        title="MORE FEATURED PROPERTIES"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
        ref={sales}
      />

      <ContactArchitecture
        title="CONTACT OLSHAN"
        tagline="Connect to Your New Home"
        classAppend="mt-50"
        ref={contact}
      />

<CTAOne
        tagline="Olshan Luxury Report"
        title="Highly focused. Data Driven."
        textButton="GET THE LATEST LUXURY REPORT"
        linkButton="/market-report"
        bg="color"
      >
        This report is the only one of its kind. On a weekly basis, Olshan publishes a report covering all the contract activity in the luxury market on properties at $4 million and above. The free report draws subscribers from all over the world, and is frequently quoted in the New York Times, Wall Street Journal, Crain's, Observer, The Real Deal and various media outlets. 
      </CTAOne>
      <FooterOne />
    </Loader>
  );
};



export default Architecture;
